export default "__VITE_ASSET__a5d70ea0__"